import { motion } from "framer-motion";
import { ArrowRight, Clock3, LockKeyhole } from "lucide-react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/content";

export const ReadinessHero = () => (
  <section className="readiness-paper relative overflow-hidden pb-20 pt-6 md:pb-28" data-testid="readiness-hero-section">
    <div className="readiness-shell">
      <header className="flex min-h-20 items-center justify-between border-b border-[#1b3f42]/15" data-testid="readiness-header">
        <Link to="/" className="flex items-center gap-3" data-testid="readiness-home-link" aria-label="Return to TENET home">
          <img src={ASSETS.logoIcon} alt="" className="h-7 w-7 object-contain" />
          <span className="text-sm font-bold tracking-[0.34em] text-[#173f42]">TENET</span>
        </Link>
        <span className="hidden text-[10px] font-semibold uppercase tracking-[0.26em] text-[#6f7269] sm:block" data-testid="readiness-header-tagline">Faith-informed transformation</span>
      </header>

      <div className="grid items-center gap-14 pt-14 lg:grid-cols-12 lg:gap-20 lg:pt-16">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="lg:col-span-6">
          <p className="readiness-kicker" data-testid="readiness-hero-eyebrow">Begin with clarity</p>
          <h1 className="mt-6 max-w-3xl font-serif text-[clamp(3.7rem,7vw,7rem)] leading-[0.84] text-[#123f43]" data-testid="readiness-hero-title">
            Is your foundation <em className="block font-normal">ready for change?</em>
          </h1>
          <p className="mt-8 max-w-xl text-base leading-8 text-[#4e5e59] md:text-lg" data-testid="readiness-hero-copy">
            The TENET Transformation Readiness Assessment helps you recognize what is supporting your growth, what may be holding you back, and where to begin.
          </p>
          <Link to="/assessment" className="readiness-primary-button mt-8 inline-flex items-center gap-6 px-6 py-4 text-sm font-semibold" data-testid="readiness-hero-assessment-cta">
            Take the readiness assessment <ArrowRight size={17} />
          </Link>
          <div className="mt-6 flex flex-wrap gap-x-7 gap-y-3 text-xs font-semibold text-[#6b716c]" data-testid="readiness-hero-meta">
            <span className="flex items-center gap-2" data-testid="readiness-duration"><Clock3 size={14} /> About 5 minutes</span>
            <span className="flex items-center gap-2" data-testid="readiness-privacy"><LockKeyhole size={14} /> Private &amp; confidential</span>
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.12 }} className="lg:col-span-6">
          <div className="readiness-image-frame ml-auto max-w-[520px]" data-testid="readiness-hero-image-frame">
            <img src={ASSETS.hero} alt="Lighthouse above a coastal path at sunrise" className="aspect-[4/5] w-full object-cover object-center" data-testid="readiness-hero-image" />
          </div>
          <div className="mt-5 flex max-w-[520px] justify-between border-t border-[#1b3f42]/15 pt-4 font-serif text-xl text-[#173f42]" data-testid="readiness-pillar-trio">
            <span>Truth</span><span>Renewal</span><span>Freedom</span>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);